<template>
  <div class="note-manage page-container">
    <el-card>
      <el-form :inline="true" :model="filterForm" class="demo-form-inline">
        <el-form-item label="关键字">
          <el-input v-model="filterForm.keyword" placeholder="标题或摘要" clearable></el-input>
        </el-form-item>
        <el-form-item label="类型">
          <el-select v-model="filterForm.type" placeholder="全部类型" clearable>
            <el-option label="普通记事" :value="0"></el-option>
            <el-option label="重要记事" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="loadNotes">查询</el-button>
          <el-button @click="resetFilters">重置</el-button>
          <el-button type="success" @click="openCreate">新增</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="notes" v-loading="isLoading" style="width: 100%">
        <el-table-column prop="title" label="标题"></el-table-column>
        <el-table-column prop="typeName" label="类型" width="120">
          <template slot-scope="scope">
            <!-- 普通: 蓝色(primary)，重要: 绿色(success) -->
            <el-tag size="mini" :type="scope.row.type === 1 ? 'success' : 'primary'">{{ scope.row.typeName }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="contentSummary" label="内容摘要"></el-table-column>
        <el-table-column prop="time" label="时间" width="180"></el-table-column>
        <el-table-column label="操作" width="340" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="success" @click="viewNote(scope.row)">查看</el-button>
            <el-button size="mini" type="primary" @click="openEdit(scope.row)">修改</el-button>
            <el-button size="mini" type="warning" @click="openHistory(scope.row)">历史</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="currentPage" :page-sizes="[5, 10, 20, 50, 100, 200, 500]" :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="totalNotes"></el-pagination>
    </el-card>
    <!-- 查看详情弹窗（全屏覆盖） -->
    <el-dialog :visible.sync="showDialog" :modal="false" append-to-body custom-class="note-dialog no-modal-dialog"
      :close-on-click-modal="false" @close="handleDialogClose">
      <div class="note-dialog-header">
        <div class="note-header-main">
          <h3 class="note-title">{{ dialogMode === 'view' ? (currentNote.title || '查看记事') : (dialogMode === 'create' ?
            '新增记事' : '修改记事') }}</h3>
          <div class="note-meta" v-if="dialogMode === 'view' && currentNote.id">
            <el-tag size="mini" :type="currentNote.type === 1 ? 'success' : 'primary'">{{ currentNote.typeName
            }}</el-tag>
            <span class="note-time">{{ currentNote.time }}</span>
          </div>
        </div>
        <div class="note-header-actions">
          <template v-if="dialogMode === 'view'">
            <el-button size="mini" type="primary" :disabled="!currentNote.id" @click="startEditFromView" v-if="!isViewingHistory">修改</el-button>
          </template>
          <template v-else>
            <el-button size="mini" @click="cancelEdit">取消</el-button>
            <el-button size="mini" type="success" :loading="isSaving" @click="submitNote">保存</el-button>
          </template>
        </div>
        <i class="el-icon-close note-close-icon" @click="closeNoteDialog"></i>
      </div>

      <div class="note-dialog-body" :class="{ 'note-dialog-form': dialogMode !== 'view' }">
        <template v-if="dialogMode === 'view'">
          <pre class="note-content-display" v-text="currentNote.content || ''"></pre>
        </template>
        <template v-else>
          <el-form :model="editForm" ref="noteFormRef" label-width="80px">
            <el-form-item label="标题" required>
              <el-input v-model="editForm.title" maxlength="100" show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="类型" required>
              <el-select v-model="editForm.type" placeholder="请选择类型" style="width: 100%" :popper-append-to-body="false">
                <el-option label="普通记事" :value="0"></el-option>
                <el-option label="重要记事" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="内容" required>
              <el-input type="textarea" :autosize="{ minRows: 8 }" v-model="editForm.content" maxlength="5000"
                show-word-limit>
              </el-input>
            </el-form-item>
          </el-form>
        </template>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeNoteDialog">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 历史版本弹窗 -->
    <el-dialog title="历史版本" :visible.sync="showHistoryDialog" width="60%" :close-on-click-modal="false">
      <el-table :data="historyList" v-loading="isLoadingHistory" style="width: 100%">
        <el-table-column prop="time" label="版本时间" width="180"></el-table-column>
        <el-table-column prop="title" label="标题"></el-table-column>
        <el-table-column label="操作" width="320" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="scope.row.isLatest" size="mini" type="primary" @click="compareWithCurrent(scope.row)">
              与当前版本对比
            </el-button>
            <template v-else>
              <el-button size="mini" type="primary" @click="compareWithNext(scope.row, scope.$index)">
                与下一版本对比
              </el-button>
            </template>
            <el-button size="mini" type="success" @click="viewHistoryDetail(scope.row)">
              查看详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 修复：历史版本分页组件，添加popper-class确保下拉框显示在正确层级 -->
      <el-pagination class="history-pagination" popper-class="history-version-dropdown"
        @size-change="handleHistorySizeChange" @current-change="handleHistoryCurrentChange" :current-page="historyPage"
        :page-sizes="[5, 10, 20, 50, 100]" :page-size="historyPageSize" layout="total, sizes, prev, pager, next, jumper"
        :total="historyTotal">
      </el-pagination>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showHistoryDialog = false">关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="版本对比"
      :visible.sync="showCompareDialog"
      width="70%"
      :close-on-click-modal="false"
      @close="handleCompareDialogClose"
      v-loading="compareLoading">
      <div v-if="compareResult" class="history-compare-container">
        <div class="compare-section">
          <div class="compare-header">
            <span>{{ compareResult.top.label }}</span>
            <span class="compare-time">{{ compareResult.top.data?.time || '--' }}</span>
          </div>
          <div class="compare-field" :class="{ diff: isFieldDifferent('title') }">
            <label>标题</label>
            <div>{{ compareResult.top.data?.title || '—' }}</div>
          </div>
          <div class="compare-field" :class="{ diff: isFieldDifferent('typeName') }">
            <label>类型</label>
            <el-tag size="mini" :type="compareResult.top.data?.type === 1 ? 'success' : 'primary'">
              {{ compareResult.top.data?.typeName || '—' }}
            </el-tag>
          </div>
          <div class="compare-field content-field" :class="{ diff: isFieldDifferent('content') }">
            <label>内容 <span class="diff-indicator" v-if="isFieldDifferent('content')">有差异</span></label>
            <div class="content-compare-view">
              <div class="content-lines">
                <div 
                  v-for="(line, idx) in compareResult.contentDiffTop"
                  :key="`top-${idx}`"
                  class="compare-line"
                  :class="{ 'line-diff': line.isDiff }">
                  <span class="line-number">{{ idx + 1 }}</span>
                  <span class="line-content" v-html="line.content"></span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <el-divider></el-divider>

        <div class="compare-section">
          <div class="compare-header">
            <span>{{ compareResult.bottom.label }}</span>
            <span class="compare-time">{{ compareResult.bottom.data?.time || '--' }}</span>
          </div>
          <div class="compare-field" :class="{ diff: isFieldDifferent('title') }">
            <label>标题</label>
            <div>{{ compareResult.bottom.data?.title || '—' }}</div>
          </div>
          <div class="compare-field" :class="{ diff: isFieldDifferent('typeName') }">
            <label>类型</label>
            <el-tag size="mini" :type="compareResult.bottom.data?.type === 1 ? 'success' : 'primary'">
              {{ compareResult.bottom.data?.typeName || '—' }}
            </el-tag>
          </div>
          <div class="compare-field content-field" :class="{ diff: isFieldDifferent('content') }">
            <label>内容 <span class="diff-indicator" v-if="isFieldDifferent('content')">有差异</span></label>
            <div class="content-compare-view">
              <div class="content-lines">
                <div 
                  v-for="(line, idx) in compareResult.contentDiffBottom"
                  :key="`bottom-${idx}`"
                  class="compare-line"
                  :class="{ 'line-diff': line.isDiff }">
                  <span class="line-number">{{ idx + 1 }}</span>
                  <span class="line-content" v-html="line.content"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="history-compare-empty">
        暂无对比数据
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showCompareDialog = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getNoteList, getNote, updateNote, addNote, deleteNote, getNoteHistory, getNoteHistoryDetail } from '@/api/note'

export default {
  name: 'NoteManage',
  data() {
    return {
      filterForm: {
        keyword: '',
        type: ''
      },
      currentPage: 1,
      pageSize: 5,
      notes: [],
      totalNotes: 0,
      isLoading: false,
      showDialog: false,
      dialogMode: 'view',
      currentNote: {},
      isSaving: false,
      editForm: {
        id: null,
        title: '',
        type: 0,
        content: ''
      },
      // 历史版本相关
      showHistoryDialog: false,
      historyList: [],
      historyPage: 1,
      historyPageSize: 5,
      historyTotal: 0,
      isLoadingHistory: false,
      currentHistoryNoteId: null,
      historyParentNoteId: null,
      showCompareDialog: false,
      compareLoading: false,
      compareResult: null,
      isViewingHistory: false // 添加一个标志来标识是否正在查看历史版本
    }
  },
  created() {
    this.loadNotes()
  },
  methods: {
    loadNotes() {
      this.isLoading = true
      const params = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        keyword: this.filterForm.keyword || undefined,
        type: this.filterForm.type === '' ? undefined : this.filterForm.type
      }
      getNoteList(params).then(res => {
        if (res.data && res.data.code === 200) {
          // 假设后端分页返回 { records, total }
          this.notes = res.data.data.records || []
          this.totalNotes = res.data.data.total || 0
        } else {
          this.$message.error(res.data && res.data.msg ? res.data.msg : '获取记事列表失败')
        }
      }).catch((error) => {
        // 检查是否是因为认证失败导致的错误（401/403）
        const status = error?.response?.status
        if (status === 401 || status === 403) {
          // 认证相关的错误已经在 axios 拦截器中处理并跳转到登录页，无需额外提示
          console.log('Authentication failed, redirecting to login page')
          this.$message.error('长时间未操作，请重新登录')
        } else {
          this.$message.error('获取记事列表异常')
        }
      }).finally(() => {
        this.isLoading = false
      })
    },

    handleSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.loadNotes()
    },

    handleCurrentChange(page) {
      this.currentPage = page
      this.loadNotes()
    },

    resetFilters() {
      this.filterForm = { keyword: '', type: '' }
      this.currentPage = 1
      this.loadNotes()
    },

    async viewNote(row) {
      try {
        this.isLoading = true
        const res = await getNote(row.id)
        if (res && res.data && res.data.code === 200) {
          this.currentNote = res.data.data
          this.dialogMode = 'view'
          this.isViewingHistory = false // 设置标志为false，表示正在查看普通笔记
          this.showDialog = true
        } else {
          this.$message.error((res && res.data && res.data.msg) || '获取记事详情失败')
        }
      } catch (e) {
        this.$message.error('获取记事异常')
      } finally {
        this.isLoading = false
      }
    },

    async openEdit(row) {
      try {
        this.isLoading = true
        const res = await getNote(row.id)
        if (res && res.data && res.data.code === 200) {
          const detail = res.data.data || {}
          this.currentNote = detail
          this.populateEditForm(detail)
          this.dialogMode = 'edit'
          this.isViewingHistory = false // 设置标志为false，表示正在编辑普通笔记
          this.showDialog = true
        } else {
          this.$message.error((res && res.data && res.data.msg) || '获取记事详情失败')
        }
      } catch (e) {
        this.$message.error('获取记事异常')
      } finally {
        this.isLoading = false
      }
    },

    openCreate() {
      this.resetEditForm()
      this.dialogMode = 'create'
      this.currentNote = {}
      this.showDialog = true
    },

    startEditFromView() {
      // 只有在不是查看历史版本时才能编辑
      if (!this.currentNote || !this.currentNote.id || this.isViewingHistory) return
      this.populateEditForm(this.currentNote)
      this.dialogMode = 'edit'
    },

    populateEditForm(note = {}) {
      this.editForm = {
        id: note.id || null,
        title: note.title || '',
        type: note.type ?? 0,
        content: note.content || ''
      }
      if (this.$refs.noteFormRef && this.$refs.noteFormRef.clearValidate) {
        this.$refs.noteFormRef.clearValidate()
      }
    },

    resetEditForm() {
      this.editForm = {
        id: null,
        title: '',
        type: 0,
        content: ''
      }
      if (this.$refs.noteFormRef && this.$refs.noteFormRef.resetFields) {
        this.$refs.noteFormRef.resetFields()
      }
    },

    cancelEdit() {
      if (this.dialogMode === 'create') {
        this.closeNoteDialog()
      } else {
        this.dialogMode = 'view'
        this.populateEditForm(this.currentNote)
      }
    },

    closeNoteDialog() {
      this.showDialog = false
    },

    handleDialogClose() {
      this.dialogMode = 'view'
      this.resetEditForm()
      this.isViewingHistory = false // 关闭对话框时重置标志
    },

    async submitNote() {
      if (!this.editForm.title || !this.editForm.title.trim()) {
        this.$message.warning('请输入标题')
        return
      }
      if (this.editForm.type !== 0 && this.editForm.type !== 1) {
        this.$message.warning('请选择类型')
        return
      }
      if (!this.editForm.content || !this.editForm.content.trim()) {
        this.$message.warning('请输入内容')
        return
      }
      const payload = {
        id: this.editForm.id,
        title: this.editForm.title.trim(),
        type: this.editForm.type,
        content: this.editForm.content.trim(),
        time: this.formatNowToString()
      }
      const prevMode = this.dialogMode
      try {
        this.isSaving = true
        const res = prevMode === 'create' ? await addNote(payload) : await updateNote(payload)
        if (res && res.data && res.data.code === 200) {
          this.$message.success(prevMode === 'create' ? '新增成功' : '修改成功')
          this.loadNotes()

          if (prevMode === 'edit') {
            // 如果没有服务器返回数据，则更新currentNote的字段
            this.currentNote.title = payload.title
            this.currentNote.type = payload.type
            this.currentNote.content = payload.content
            this.currentNote.time = payload.time

            // 从查看弹窗进入的修改，修改成功后返回查看模式
            this.dialogMode = 'view'
          } else if (prevMode === 'create') {
            this.showDialog = false
          }
        } else {
          this.$message.error((res && res.data && res.data.msg) || '保存失败')
        }
      } catch (e) {
        const errorMsg = e?.response?.data?.msg || e?.response?.data?.message || e?.message || '保存失败'

        // 修复：在catch块中使用this.$message.error显示错误信息
        // 由于当前弹窗使用了无遮罩模式，可能影响message组件的显示
        // 使用$nextTick确保DOM更新后再显示message
        this.$nextTick(() => {
          this.$message.error(errorMsg)
        })
      } finally {
        this.isSaving = false
      }
    },

    async handleDelete(row) {
      if (!row || !row.id) {
        this.$message.warning('无法删除，缺少记录ID')
        return
      }

      try {
        await this.$confirm(`确定要删除记事"${row.title || '未命名'}"吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          modal: false
        })

        const res = await deleteNote(row.id)
        if (res && res.data && res.data.code === 200) {
          this.$message.success('删除成功')
          // 如果删除的是当前查看的记录，关闭弹窗
          if (this.currentNote && this.currentNote.id === row.id) {
            this.showDialog = false
          }
          // 刷新列表
          this.loadNotes()
        } else {
          this.$message.error((res && res.data && res.data.msg) || '删除失败')
        }
      } catch (e) {
        // 用户取消删除
        if (e === 'cancel') {
          return
        }
        const errorMsg = e?.response?.data?.msg || e?.response?.data?.message || e?.message || '删除失败'
        this.$message.error(errorMsg)
        console.error('删除失败:', e)
      }
    },

    // 生成当前时间的 yyyy/MM/dd HH:mm:ss 字符串（使用本地时间）
    formatNowToString() {
      const d = new Date()
      const pad = n => (n < 10 ? '0' + n : '' + n)
      const year = d.getFullYear()
      const month = pad(d.getMonth() + 1)
      const day = pad(d.getDate())
      const hour = pad(d.getHours())
      const minute = pad(d.getMinutes())
      const second = pad(d.getSeconds())
      return `${year}/${month}/${day} ${hour}:${minute}:${second}`
    },

    // 打开历史版本弹窗
    openHistory(row) {
      if (!row || !row.id) {
        this.$message.warning('无法查看历史版本，缺少记录ID')
        return
      }
      this.currentHistoryNoteId = row.id
      this.historyParentNoteId = row.id
      this.historyPage = 1
      this.showHistoryDialog = true
      this.loadHistoryList()
    },

    // 加载历史版本列表
    async loadHistoryList() {
      if (!this.currentHistoryNoteId) {
        return
      }
      this.isLoadingHistory = true
      try {
        const params = {
          noteId: this.currentHistoryNoteId,
          pageNum: this.historyPage,
          pageSize: this.historyPageSize
        }
        const res = await getNoteHistory(params)
        if (res && res.data && res.data.code === 200) {
          const data = res.data.data
          // 判断返回的数据结构：如果是数组，直接使用；如果是对象，提取列表和总数
          if (Array.isArray(data)) {
            this.historyList = data
            // 如果返回的是数组且长度等于pageSize，可能还有更多数据，这里暂时用数组长度
            // 实际应该由后端返回total字段
            this.historyTotal = data.length
          } else if (data && Array.isArray(data.records)) {
            // 如果后端返回的是分页对象 { records: [], total: 100 }
            this.historyList = data.records || []
            this.historyTotal = data.total || 0
          } else {
            this.historyList = []
            this.historyTotal = 0
          }
        } else {
          this.$message.error((res && res.data && res.data.msg) || '获取历史版本失败')
          this.historyList = []
          this.historyTotal = 0
        }
      } catch (e) {
        const errorMsg = e?.response?.data?.msg || e?.response?.data?.message || e?.message || '获取历史版本异常'
        this.$message.error(errorMsg)
        this.historyList = []
        this.historyTotal = 0
        console.error('获取历史版本失败:', e)
      } finally {
        this.isLoadingHistory = false
      }
    },

    // 历史版本分页大小改变
    handleHistorySizeChange(size) {
      this.historyPageSize = size
      this.historyPage = 1
      this.loadHistoryList()
    },

    // 历史版本页码改变
    handleHistoryCurrentChange(page) {
      this.historyPage = page
      this.loadHistoryList()
    },

    // 与当前版本对比
    async compareWithCurrent(row) {
      const currentNoteId = this.historyParentNoteId || row.noteId
      if (!currentNoteId) {
        this.$message.warning('无法获取当前版本信息')
        return
      }
      this.compareResult = null
      this.compareLoading = true
      try {
        const [currentRes, historyRes] = await Promise.all([
          getNote(currentNoteId),
          getNoteHistoryDetail(row.id)
        ])
        if ((currentRes?.data?.code === 200) && (historyRes?.data?.code === 200)) {
          const topData = currentRes.data.data || {}
          const bottomData = historyRes.data.data || {}
          
          // 分析内容差异
          const { resultA, resultB } = this.analyzeLineDiff(topData.content, bottomData.content)
          
          this.compareResult = {
            top: { label: '当前版本', data: topData },
            bottom: { label: '历史版本', data: bottomData },
            contentDiffTop: resultA,
            contentDiffBottom: resultB
          }
          this.showCompareDialog = true
        } else {
          this.$message.error('获取对比数据失败')
        }
      } catch (e) {
        const msg = e?.response?.data?.msg || e?.message || '获取对比数据失败'
        this.$message.error(msg)
      } finally {
        this.compareLoading = false
      }
    },

    // 与下一版本对比
    async compareWithNext(row, index) {
      const nextRow = this.historyList[index - 1]
      if (!nextRow) {
        this.$message.warning('没有更多历史版本可供对比')
        return
      }
      this.compareResult = null
      this.compareLoading = true
      try {
        const [currentDetail, prevDetail] = await Promise.all([
          getNoteHistoryDetail(row.id),
          getNoteHistoryDetail(nextRow.id)
        ])
        if ((currentDetail?.data?.code === 200) && (prevDetail?.data?.code === 200)) {
          const topData = currentDetail.data.data || {}
          const bottomData = prevDetail.data.data || {}
          
          // 分析内容差异
          const { resultA, resultB } = this.analyzeLineDiff(topData.content, bottomData.content)
          
          this.compareResult = {
            top: { label: '当前历史版本', data: topData },
            bottom: { label: '下一历史版本', data: bottomData },
            contentDiffTop: resultA,
            contentDiffBottom: resultB
          }
          this.showCompareDialog = true
        } else {
          this.$message.error('获取历史版本对比数据失败')
        }
      } catch (e) {
        const msg = e?.response?.data?.msg || e?.message || '获取历史版本对比数据异常'
        this.$message.error(msg)
      } finally {
        this.compareLoading = false
      }
    },

    // 查看历史版本详情：使用主页面"查看"弹窗展示
    async viewHistoryDetail(row) {
      if (!row || !row.id) {
        this.$message.warning('无法查看历史版本详情，缺少ID')
        return
      }

      try {
        this.isLoadingHistory = true
        const res = await getNoteHistoryDetail(row.id)
        if (res && res.data && res.data.code === 200) {
          const detail = res.data.data || {}
          // 复用主页面查看弹窗
          this.currentNote = detail
          this.dialogMode = 'view'
          this.isViewingHistory = true // 设置标志为true，表示正在查看历史版本
          this.showDialog = true
          // 可以根据需要选择是否关闭历史弹窗，这里保持打开，方便切换查看
          // this.showHistoryDialog = false
        } else {
          this.$message.error((res && res.data && res.data.msg) || '获取历史版本详情失败')
        }
      } catch (e) {
        const errorMsg = e?.response?.data?.msg || e?.response?.data?.message || e?.message || '获取历史版本详情异常'
        this.$message.error(errorMsg)
        // eslint-disable-next-line no-console
        console.error('获取历史版本详情失败:', e)
      } finally {
        this.isLoadingHistory = false
      }
    },

    handleCompareDialogClose() {
      this.compareResult = null
    },

    isFieldDifferent(field) {
      if (!this.compareResult) return false
      const topValue = this.compareResult.top?.data?.[field] ?? ''
      const bottomValue = this.compareResult.bottom?.data?.[field] ?? ''
      return topValue !== bottomValue
    },

    // 差异分析：计算两个内容之间的行级差异
    analyzeLineDiff(contentA, contentB) {
      const linesA = (contentA || '').split('\n')
      const linesB = (contentB || '').split('\n')
      
      // 构建差异结构
      const resultA = linesA.map((line, idx) => {
        const isDiff = idx >= linesB.length || line !== linesB[idx]
        return {
          content: this.escapeHtml(line) || '&nbsp;',
          isDiff
        }
      })
      
      const resultB = linesB.map((line, idx) => {
        const isDiff = idx >= linesA.length || line !== linesA[idx]
        return {
          content: this.escapeHtml(line) || '&nbsp;',
          isDiff
        }
      })
      
      return { resultA, resultB }
    },

    // HTML转义
    escapeHtml(text) {
      if (!text) return ''
      const div = document.createElement('div')
      div.textContent = text
      return div.innerHTML
    }
  }
}
</script>

<style lang="scss" scoped>
.note-manage {
  padding: 0;
  background-color: #f5f7fa;

  &.page-container {
    margin-top: -10px;
  }

  .el-card {
    margin-bottom: 12px;
  }

  .el-form-item {
    margin-bottom: 12px;
  }

  .pagination {
    margin-top: 12px;
    display: flex;
    justify-content: flex-end;
  }
}

/* 表格表头样式 */
:deep(.el-table__header-wrapper th),
:deep(.el-table__fixed-header-wrapper th) {
  background-color: #f5f7fa !important;
}

:deep(.note-dialog) {

  /* 全屏查看弹窗样式（右侧内容区全覆盖，保留左侧菜单） */
  .el-dialog__header {
    display: none;
  }

  .note-dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 48px 6px 16px;
    /* 右侧留出空间给关闭按钮 */
    height: 44px;
    /* 强制高度，避免竖向撑大 */
    border-bottom: 1px solid #e6e9ec;
    background: linear-gradient(180deg, #ffffff, #fafbfc);
    position: relative;
  }

  .note-title {
    margin: 0;
    font-size: 15px;
    /* 更小的标题 */
    line-height: 1;
    color: #2c3e50;
    max-height: 22px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .note-meta {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-right: 16px;
    /* 避免和关闭按钮贴在一起 */
  }

  .note-time {
    color: #909399;
  }

  .note-close-icon {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 18px;
    color: #909399;
    cursor: pointer;
    transition: color 0.2s;
  }

  .note-close-icon:hover {
    color: #f56c6c;
  }

  .note-dialog-body {
    padding: 12px 20px 84px;
    /* 底部留出空间给固定的关闭按钮 */
    flex: 1;
    min-height: 0;
    /* 避免撑高外层导致页面滚动 */
    height: 100%;
    background: #fff;
    display: flex;
    flex-direction: column;
    /* 默认不滚动，由内部内容区自己控制滚动 */
    overflow: hidden;
    box-sizing: border-box;
  }

  /* 编辑 / 新增 时让表单区域内部滚动 */
  .note-dialog-body.note-dialog-form {
    overflow: hidden;
  }

  .note-dialog-body.note-dialog-form .el-form {
    flex: 1;
    min-height: 0;
    max-height: calc(100vh - 160px);
    /* 预留头部和底部空间 */
    overflow-y: auto;
    padding-right: 8px;
    box-sizing: border-box;
  }

  /* 无遮罩模式：将对话框限制在侧栏右侧显示（仅保留左侧菜单） */
  &.no-modal-dialog {
    position: fixed !important;
    /* 覆盖除左侧菜单外的所有可视区域（包括顶部导航） */
    top: 0 !important;
    bottom: 0 !important;
    left: 220px !important;
    /* 菜单宽度 */
    right: 0 !important;
    width: auto !important;
    height: auto !important;
    margin: 0 !important;
    overflow: hidden;
    /* 禁掉整体竖向滚动条 */
  }

  &.no-modal-dialog .el-dialog {
    margin: 0 !important;
    width: 100% !important;
    height: 100% !important;
    display: flex;
    flex-direction: column;
    box-shadow: none;
  }

  &.no-modal-dialog .el-dialog__body {
    max-height: none !important;
    padding: 0 !important;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;
  }
}

.note-content-display {
  white-space: pre-wrap;
  /* 保留换行和缩进 */
  word-break: break-word;
  font-family: SFMono-Regular, Menlo, Monaco, 'Courier New', monospace;
  font-size: 14px;
  line-height: 1.6;
  color: #2d3a45;
  flex: unset;
  overflow: visible;
  min-height: unset;
  /* 添加滚动条样式 */
  max-height: calc(100vh - 120px);
  /* 限制最大高度，减去头部和底部空间 */
  overflow-y: auto;
  /* 当内容过多时显示滚动条 */
  padding: 8px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background-color: #fafafa;
  margin: 0;
}

/* 选中文本样式 */
::selection {
  background: rgba(255, 154, 158, 0.3);
  color: #333
}

::-moz-selection {
  background: rgba(255, 154, 158, 0.3);
  color: #333
}

/* 固定底部关闭按钮样式 */
.note-dialog .dialog-footer {
  position: absolute;
  right: 24px;
  bottom: 18px;
  z-index: 10001;
}

  .history-compare-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .compare-section {
    padding: 8px 0;
  }

  .compare-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 600;
    margin-bottom: 12px;
  }

  .compare-time {
    font-size: 12px;
    color: #909399;
  }

  .compare-field {
    margin-bottom: 12px;
    padding: 8px 12px;
    border: 1px solid #f0f0f0;
    border-radius: 4px;
    background: #fafafa;
  }

  .compare-field.diff {
    border-color: #f56c6c;
    background: #fff5f5;
  }

  .compare-field label {
    display: inline-block;
    font-size: 12px;
    color: #909399;
    margin-bottom: 6px;
  }

  .diff-indicator {
    display: inline-block;
    background: #f56c6c;
    color: white;
    font-size: 11px;
    padding: 2px 6px;
    border-radius: 2px;
    margin-left: 8px;
    font-weight: normal;
  }

  .compare-field pre {
    margin: 0;
    white-space: pre-wrap;
    font-family: SFMono-Regular, Menlo, Monaco, 'Courier New', monospace;
  }

  /* 内容对比视图 */
  .content-compare-view {
    background: #fff;
    border: 1px solid #e6e9ec;
    border-radius: 2px;
    overflow-x: auto;
    max-height: 300px;
    overflow-y: auto;
  }

  .content-lines {
    display: flex;
    flex-direction: column;
    font-family: 'SFMono-Regular', 'Monaco', 'Menlo', 'Ubuntu Mono', 'Courier New', monospace;
    font-size: 13px;
    line-height: 1.6;
  }

  .compare-line {
    display: flex;
    align-items: flex-start;
    padding: 0;
    border-bottom: 1px solid #f0f0f0;
    background: #fafafa;
  }

  .compare-line.line-diff {
    background: #fff4e6;
    border-left: 3px solid #f56c6c;
  }

  .compare-line:hover {
    background: #f5f7fa;
  }

  .compare-line.line-diff:hover {
    background: #ffe6e6;
  }

  .line-number {
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    min-width: 40px;
    padding: 0 8px;
    color: #909399;
    font-size: 12px;
    user-select: none;
    background: #f0f0f0;
    border-right: 1px solid #e6e9ec;
    flex-shrink: 0;
  }

  .compare-line.line-diff .line-number {
    background: #ffdddd;
  }

  .line-content {
    flex: 1;
    padding: 0 12px;
    white-space: pre-wrap;
    word-break: break-word;
    color: #2c3e50;
  }

  .history-compare-empty {
    text-align: center;
    color: #909399;
    padding: 40px 0;
  }

/* 全局覆盖：确保遮罩和 wrapper 在最顶层，覆盖左侧菜单 */
/* 该样式为全局，需要写到不带 scoped 的 style 才能生效；为了避免影响其他组件，仅调高 z-index */
</style>

/* 全局样式：提升 dialog 遮罩和 wrapper 的 z-index（确保覆盖侧边菜单） */
<style>
.v-modal {
  z-index: 99998 !important;
}

.el-dialog__wrapper {
  z-index: 99999 !important;
}

/* 修复message组件在全屏对话框模式下的显示问题 */
.el-message {
  z-index: 100000 !important;
}

/* 修复下拉选择框在全屏对话框中的显示问题 */
:deep(.el-select-dropdown) {
  z-index: 100001 !important;
}

/* 修复删除确认对话框的遮罩层问题 */
.el-message-box__wrapper {
  z-index: 100002 !important;
}

/* 隐藏确认对话框的遮罩层，避免覆盖整个页面 */
.v-modal[style*="z-index: 2001"] {
  display: none !important;
}

/* 历史版本弹窗样式 */
.history-pagination {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

/* ===== 全局层级修复 START ===== */

.history-version-dropdown,
.el-select-dropdown {
  z-index: 200010 !important;
}

/* 你原本的 z-index 结构保留，不动 */
.v-modal {
  z-index: 99998 !important;
}

.el-dialog__wrapper {
  z-index: 99999 !important;
}

.el-message {
  z-index: 100000 !important;
}

.el-message-box__wrapper {
  z-index: 100002 !important;
}

/* ===== 全局层级修复 END ===== */
</style>